import React from 'react'
import {
  COMPANY_LEGAL_REPRESENTATIVES,
  LEGAL_REPRESENTATIVE_IS_SIGNATORY,
  withHideIfNotVisible,
  useInputNameSpecificTranslationKey,
  RadioGroupComponent,
  useInputIsReadonly,
  useRenderPersistedObject,
} from '@modifi/plugin-onboarding'

import {FormInputComponentCol} from '../../../../../plugins/onboarding'
import {FormRow} from '../../../../../ui/form'
import {TranslateFn} from '../../../../../types/common'

type IsSignatoryInputRowProps = {
  t: TranslateFn
}

const IsSignatoryInputRow: React.FC<IsSignatoryInputRowProps> = ({t}) => {
  const isReadOnly = useInputIsReadonly(COMPANY_LEGAL_REPRESENTATIVES)
  const inputNameSpecific = useInputNameSpecificTranslationKey()

  const radioOptions = [
    {
      label: t(inputNameSpecific(LEGAL_REPRESENTATIVE_IS_SIGNATORY, 'value.true')),
      value: true,
      colProps: {
        auto: true,
      },
    },
    {
      label: t(inputNameSpecific(LEGAL_REPRESENTATIVE_IS_SIGNATORY, 'value.false')),
      value: false,
      colProps: {
        auto: true,
      },
    },
  ]
  const inputProps = useRenderPersistedObject({disabled: isReadOnly})

  return (
    <FormRow mb={16}>
      <FormInputComponentCol
        t={t}
        inputComponent={RadioGroupComponent}
        inputName={LEGAL_REPRESENTATIVE_IS_SIGNATORY}
        options={radioOptions}
        inputProps={inputProps}
      />
    </FormRow>
  )
}

export default withHideIfNotVisible(IsSignatoryInputRow, LEGAL_REPRESENTATIVE_IS_SIGNATORY)
